import Model from 'mixins/model';
import CoverModel from 'models/CoverModel';

export default class CoverDayModel extends Model {
    constructor() {
        super();
        this.set('covers', []);
    }
    addCover(coverModel) {
        this.get('covers').push(coverModel);
    }
    bulkAddCovers(covers) {
        covers.forEach((model) => {
            const coverModel = CoverModel.fromJSON(model);
            this.get('covers').push(coverModel);
        });
    }
}



// WEBPACK FOOTER //
// ./src/RMPL/CoreBundle/Resources/public/js/models/CoverDayModel.js